'use strict';

var React = require('react');

var SvgBlogMajor = function SvgBlogMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16 2a2 2 0 0 1 4 0v1h-4v-1zm-7.621-1a1.5 1.5 0 0 1 1.06.44l4.122 4.12a1.5 1.5 0 0 1 .439 1.062v10.878a1.5 1.5 0 0 1-1.5 1.5h-10a1.5 1.5 0 0 1-1.5-1.5v-15a1.5 1.5 0 0 1 1.5-1.5h5.879zm-4.379 4h4v2h-4v-2zm7 4v2h-7v-2h7zm-7 6v-2h5v2h-5zm12-10h4v11l-2 4-2-4v-11z"
  }));
};

exports.SvgBlogMajor = SvgBlogMajor;
